import Swiper from 'swiper';
import {
    Navigation,
    Pagination,
    Keyboard,
    Autoplay,
    EffectFade,
} from 'swiper/modules';

// import AOS from 'aos';

Swiper.use([Navigation, Pagination, Keyboard, Autoplay, EffectFade]);

const navigation = (target) => {
    return {
        nextEl: `.${target}-swiper-button--next`,
        prevEl: `.${target}-swiper-button--prev`,
    };
};

$(window).on('load', function () {
    swipers();
});

const swipers = () => {
    bikeBrandItemsFull();
    bikeBrandItemsHalf();
    bikeBrandModels();
    reviewSwiper();
    brandSwiper();
    singleBikeSwiper();
    teamSwiper();
};

const reviewSwiper = () => {
    return new Swiper('.module--reviews__items__slider', {
        loop: false,
        spaceBetween: 40,
        slidesPerView: 1,
        autoHeight: true,
        navigation: navigation('module--reviews__items__slider__nav'),
    });
};

const brandSwiper = () => {
    return new Swiper('.module--brands__wrapper__slider', {
        loop: true,
        freeMode: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        //   speed: 3500,
        spaceBetween: 30,
        centerInsufficientSlides: true,
        freeModeMomentum: false,
        navigation: navigation('module--brands__wrapper__slider__nav'),
        breakpoints: {
            1700: {
                slidesPerView: 7,
            },
            1400: {
                slidesPerView: 6,
            },
            1100: {
                slidesPerView: 5,
            },
            800: {
                slidesPerView: 4,
            },
            600: {
                slidesPerView: 3,
            },
            0: {
                slidesPerView: 2,
            },
        },
    });
};

const bikeBrandModels = () => {
    return new Swiper('.bike-brand-item__models', {
        loop: true,
        spaceBetween: 30,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        navigation: navigation('bike-brand-item__models__nav'),
        slidesPerView: 1,
        pagination: {
            el: '.bike-brand-item__models .swiper-pagination',
            dynamicBullets: false,
            clickable: true,
        },
    });
};

const bikeBrandItemsFull = () => {
    return new Swiper('.module--bike-brands__items--full', {
        loop: false,
        spaceBetween: 14,
        navigation: navigation('module--bike-brands__items__nav'),
        slidesPerView: 1.1,
        breakpoints: {
            1500: {
                slidesPerView: 4,
            },
            992: {
                slidesPerView: 3,
            },
            660: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1.1,
            },
        },
        on: {
            resize: function () {
                var hideNav = this.slides.length <= this.params.slidesPerView;
                $('.module--bike-brands__items__nav', this.el).toggle(!hideNav);
            },
            init: function () {
                var hideNav = this.slides.length <= this.params.slidesPerView;
                $('.module--bike-brands__items__nav', this.el).toggle(!hideNav);
            },
        },
    });
};

const bikeBrandItemsHalf = () => {
    return new Swiper('.module--bike-brands__items--half', {
        loop: false,
        spaceBetween: 14,
        navigation: navigation('module--bike-brands__items__nav'),
        slidesPerView: 1.1,
        breakpoints: {
            660: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1.1,
            },
        },
        on: {
            resize: function () {
                var hideNav = this.slides.length <= this.params.slidesPerView;
                $('.module--bike-brands__items__nav', this.el).toggle(!hideNav);
            },
            init: function () {
                var hideNav = this.slides.length <= this.params.slidesPerView;
                $('.module--bike-brands__items__nav', this.el).toggle(!hideNav);
            },
        },
    });
};

const singleBikeSwiper = () => {
    return new Swiper('.single-bike__slider', {
        loop: true,
        // spaceBetween: 30,
        navigation: navigation('single-bike__slider__nav'),
        slidesPerView: 1,
        on: {
            resize: function () {
                var hideNav = this.slides.length <= this.params.slidesPerView;
                $('.single-bike__slider__nav').toggle(!hideNav);
            },
            init: function () {
                var hideNav = this.slides.length <= this.params.slidesPerView;
                $('.single-bike__slider__nav').toggle(!hideNav);
            },
        },
    });
}

const teamSwiper = () => {
    return new Swiper('.team-slider', {
        loop: false,
        spaceBetween: 12,
        breakpoints: {
            1500: {
                slidesPerView: 3.2,
            },
            992: {
                slidesPerView: 3,
            },
            660: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1,
            },
        },
        navigation: navigation('team-slider__nav'),
        on: {
            resize: function () {
                var hideNav = this.slides.length <= this.params.slidesPerView;
                $('.team-slider__nav').toggle(!hideNav);
            },
            init: function () {
                var hideNav = this.slides.length <= this.params.slidesPerView;
                $('.team-slider__nav').toggle(!hideNav);
            },
        },
    });
}

// $(window).on('resize', function () {
//     AOS.refresh();
// });
